module.exports = __webpack_public_path__ + "img/login-bg-v1.45ae5858.jpg";